import VadImage from "vadimages-nextjs-image-optimizer";

interface ICustomization {
  imageSrc: string;
  imageWidth: number;
  imageHeight: number;
  bgColor: string;
  hideOnMobile: boolean;
  productName?: string;
  productDescription?: string;
}

const europeLanderCustomizations = [
  {
    imageSrc: "/images/european-lander/customizations/customization.1.png",
    imageWidth: 111,
    imageHeight: 270,
    bgColor: "#EED025",
    hideOnMobile: false,
    productName: "Axil Mini Air",
    productDescription: "Custom color injection molded mouthpiece, semi-gloss painted body with 1-color logo print",
  },
  {
    imageSrc: "/images/european-lander/customizations/customization.2.png",
    imageWidth: 138,
    imageHeight: 270,
    bgColor: "#E33400",
    hideOnMobile: true,
    productName: "EZ Click Ceramic Pro",
    productDescription: "Custom color injection molded mouthpiece with 1-color logo on tank",
  },
  {
    imageSrc: "/images/european-lander/customizations/customization.3.png",
    imageWidth: 182,
    imageHeight: 270,
    bgColor: "#816FC5",
    hideOnMobile: true,
    productName: "Axil",
    productDescription: "Hydrographic print, gloss finish, custom color injection molded mouthpiece",
  },
  {
    imageSrc: "/images/european-lander/customizations/customization.4.png",
    imageWidth: 160,
    imageHeight: 270,
    bgColor: "#57BDFF",
    hideOnMobile: false,
    productName: "Leaf",
    productDescription: "Custom color injection mold with 1-color print, rubberized soft-touch finish",
  },
  {
    imageSrc: "/images/european-lander/customizations/customization.5.png",
    imageWidth: 190,
    imageHeight: 270,
    bgColor: "#2C2B2B",
    hideOnMobile: true,
    productName: "Leaf",
    productDescription: "3-color print, rubberized soft-touch finish",
  },
  {
    imageSrc: "/images/european-lander/customizations/customization.6.png",
    imageWidth: 55,
    imageHeight: 270,
    bgColor: "#519A27",
    hideOnMobile: false,
    productName: "EZ Click Ceramic Pro",
    productDescription: "Custom color injection molded mouthpiece, 2-color logo on tank, 360° logo band",
  },
  {
    imageSrc: "/images/european-lander/customizations/customization.7.png",
    imageWidth: 80,
    imageHeight: 270,
    bgColor: "#1B30F2",
    hideOnMobile: false,
    productName: "Axil Mini Pro",
    productDescription: "Custom color injection molded mouthpiece with 1-color print, rubberized painted body with 1-color logo print and custom color injection molded endcap",
  },
  {
    imageSrc: "/images/european-lander/customizations/customization.8.png",
    imageWidth: 138,
    imageHeight: 270,
    bgColor: "#EDC000",
    hideOnMobile: true,
    productName: "Leaf",
    productDescription: "3-color print, rubberized soft-touch finish",
  },
];

const CustomizationBlock = ({
  f,
  imageSizeCoefficient = 1,
}: {
  f: ICustomization;
  imageSizeCoefficient?: number;
}) => (
  <div
    style={{ backgroundColor: f.bgColor }}
    className="w-full h-[250px] md:h-[380px] overflow-hidden"
  >
    <div className="w-[200%] h-full flex duration-300 hover:-translate-x-1/2">
      <figure className="w-1/2 flex items-center justify-center">
        <VadImage
          src={f.imageSrc}
          width={f.imageWidth * imageSizeCoefficient}
          height={f.imageHeight * imageSizeCoefficient}
          alt=""
        />
      </figure>
      <div className="w-1/2 px-4 flex items-center justify-center">
        <div className="text-lg max-w-full text-white text-center">
          <p className="font-semibold">{f.productName}</p>
          <p>{f.productDescription}</p>
        </div>
      </div>
    </div>
  </div>
);

const _CustomizationBlock = ({
  f,
  imageSizeCoefficient = 1,
}: {
  f: ICustomization;
  imageSizeCoefficient?: number;
}) => (
  <figure
    style={{ backgroundColor: f.bgColor }}
    className="w-full h-[250px] md:h-[380px] flex items-center justify-center"
  >
    <VadImage
      src={f.imageSrc}
      width={f.imageWidth * imageSizeCoefficient}
      height={f.imageHeight * imageSizeCoefficient}
      alt=""
    />
  </figure>
);

export const CustomizationBlocks = () => {
  return (
    <>
      {/* DESKTOP */}
      <div className="hidden md:grid w-full rounded-default grid-cols-4 overflow-hidden">
        {europeLanderCustomizations.map((f, idx) => (
          <CustomizationBlock key={`eu-customization-${idx}`} f={f} />
        ))}
      </div>

      {/* MOBILE */}
      <div className="grid md:hidden w-full rounded-default grid-cols-2 overflow-hidden">
        {europeLanderCustomizations
          .filter((f) => !f.hideOnMobile)
          .map((f, idx) => (
            <CustomizationBlock
              key={`eu-customization-${idx}`}
              f={f}
              imageSizeCoefficient={0.7}
            />
          ))}
      </div>
    </>
  );
};
